
import global from '@/utils/global'
import { defineComponent } from 'vue'
import { getDispatchExamine, cancelDispatchExamine, getCompanyList } from '@/api/long-insure'
import { BillDetailDto, BillDto } from '@/api/bill'
import batchPayroll from '@/components/batch-payroll.vue'
import { insureDispatchList, insureDispatchDelete, addDispatch } from '@/api/insure-deduction'
import { getInsureBalanceAxRechargeApi } from '@/api/insure-daily-ax'
import { ElMessage, ElMessageBox } from 'element-plus'
import { payModeList } from '../utils/insure-daily-ax-dict'
import { formatter, downloadBlobFile } from '../utils/util'

export default defineComponent({
  name: 'InsureDailyBillInfo',
  components: {},
  data() {
    return {
      formatter,
      payModeList,
      active: '1',
      formSearch: {
        projectTime: ''
      },
      pageSize1: 10,
      pageNum1: 1,
      total1: 0,
      pageSize2: 10,
      pageNum2: 1,
      total2: 0,
      pageSize3: 10,
      pageNum3: 1,
      total3: 0,
      tableData1: [],
      tableData2: [],
      tableData3: [],
      selects: [] as string[] // 列表选中
    }
  },
  created() {
    this.getList1()
  },
  watch: {},
  methods: {
    // clickTab
    async clickTab(val) {
      switch (val) {
        case '1':
          this.getList1()
          break
        case '2':
          this.getList2()
          break
        case '3':
          this.getList3()
          break
      }
    },

    // 充值记录分野
    async getList1(str) {
      let param = {
        beginUpdateTime: this.formSearch.projectTime[0] || '',
        endUpdateTime: this.formSearch.projectTime[1] || '',
        pageSize: this.pageSize1,
        pageNum: this.pageNum1,
        statusList: '0,1,2'
      }
      const result = await getInsureBalanceAxRechargeApi(param)
      console.log(result.list, this.active, 'getList1')
      this.tableData1 = result.list
      this.total1 = result.totalCount
    },

    async getList2(str) {
      let param = {
        beginUpdateTime: this.formSearch.projectTime[0] || '',
        endUpdateTime: this.formSearch.projectTime[1] || '',
        pageSize: this.pageSize2,
        pageNum: this.pageNum2,
        statusList: '4,5'
      }
      const result = await getInsureBalanceAxRechargeApi(param)
      console.log(result.list, this.active, 'getList2')
      this.tableData2 = result.list
      this.total2 = result.totalCount
    },
    async getList3(str) {
      let param = {
        beginUpdateTime: this.formSearch.projectTime[0] || '',
        endUpdateTime: this.formSearch.projectTime[1] || '',
        pageSize: this.pageSize3,
        pageNum: this.pageNum3,
        statusList: '3'
      }
      const result = await getInsureBalanceAxRechargeApi(param)
      console.log(result.list, this.active, 'getList3')
      this.tableData3 = result.list
      this.total3 = result.totalCount
    },
    onSearch() {
      switch (this.active) {
        case '1':
          this.getList1()
          break
        case '2':
          this.getList2()
          break
        case '3':
          this.getList3()
          break
      }
    },
    onReset() {
      this.formSearch = {
        projectTime: ''
      }
      switch (this.active) {
        case '1':
          this.getList1()
          break
        case '2':
          this.getList2()
          break
        case '3':
          this.getList3()
          break
      }
    },
    handleSizeChange1() {
      this.getList1()
    },
    handleSizeChange2() {
      this.getList2()
    },
    handleSizeChange3() {
      this.getList3()
    },

    handleSelectionChange(selects: { id: string }[]) {
      this.selects = selects.map((item) => item.id)
    }
  }
})
